var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "_x32_",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:white}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.698 141.549H79.077c-8.488 0-15.37 6.882-15.37 15.362V355.09c0 8.479 6.882 15.362 15.37 15.362h62.622c8.489 0 15.371-6.883 15.371-15.362V156.911c0-8.48-6.883-15.362-15.372-15.362M32.374 189.734H12.803C5.736 189.734 0 195.47 0 202.537v106.925c0 7.068 5.736 12.803 12.803 12.803h19.571c7.067 0 12.803-5.736 12.803-12.803V202.537c0-7.067-5.736-12.803-12.803-12.803M177.69 228.894h156.62v54.212H177.69zM432.922 141.549h-62.621c-8.488 0-15.371 6.882-15.371 15.362V355.09c0 8.479 6.882 15.362 15.371 15.362h62.621c8.488 0 15.371-6.883 15.371-15.362V156.911c0-8.48-6.882-15.362-15.371-15.362M499.197 189.734h-19.57c-7.068 0-12.803 5.736-12.803 12.803v106.925c0 7.068 5.736 12.803 12.803 12.803h19.57c7.068 0 12.803-5.736 12.803-12.803V202.537c0-7.067-5.736-12.803-12.803-12.803",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.198d9eb583527ad1049958cd795eb362.svg";
export { ForwardRef as ReactComponent };